import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import pailleKraft from "@/assets/products/paille-kraft.jpg";
import pailleNoire from "@/assets/products/paille-noire.jpg";

const config: ProductPageConfig = {
  name: "Pailles en papier biodégradables",
  breadcrumbName: "Pailles papier",
  subtitle: "Alternative écologique aux pailles plastiques, résistantes et biodégradables",
  features: ["Biodégradable", "FSC certifié", "Contact alimentaire", "Chaud & froid", "Disponible en stock"],
  variants: [
    { ref: "GCANAP8X140", name: "Paille noire 140mm", dimensions: "140 x 8 mm", material: "Carton", color: "Noir", packaging: "Carton de 5 000 (50 x 100)", palette: "-", image: pailleNoire },
    { ref: "GCANAPNG", name: "Paille noire 200mm", dimensions: "200 x 6 mm", material: "Carton", color: "Noir", packaging: "Carton de 5 000 (50 x 100)", palette: "-", image: pailleNoire },
    { ref: "GCANAPKR", name: "Paille kraft 200mm", dimensions: "200 x 6 mm", material: "Carton", color: "Kraft", packaging: "Carton de 5 000 (50 x 100)", palette: "-", image: pailleKraft },
    { ref: "GCANAPENFK", name: "Paille kraft emballée", dimensions: "200 x 6 mm", material: "Carton", color: "Kraft (emballé)", packaging: "Carton de 5 000 (50 x 100)", palette: "-", image: pailleKraft },
    { ref: "GCANAPBC", name: "Paille blanche 200mm", dimensions: "200 x 6 mm", material: "Carton", color: "Blanc", packaging: "Carton de 5 000 (50 x 100)", palette: "-", image: pailleKraft },
    { ref: "GCANAP210x12", name: "Paille kraft XL", dimensions: "210 x 12 mm", material: "Carton", color: "Kraft", packaging: "Carton de 2 500 (50 x 50)", palette: "-", image: pailleKraft },
  ],
};

const Pailles = () => <ProductPageLayout config={config} />;
export default Pailles;
